import React, { useState, useRef, useEffect } from 'react';
import './ImageCarousel.css';
import VideoModal from './VideoModal';
import BottomBar from './BottomBar';
import CircularMenu from './CircularMenu';

const handleDownload = () => {
  const link = document.createElement('a');
  link.href = './resume.docx';
  link.download = 'resume.docx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const ImageCarousel = ({ images }) => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const scrollRef = useRef(null);
  const itemWidthRef = useRef(0);

  useEffect(() => {
    if (scrollRef.current && scrollRef.current.firstChild) {
      itemWidthRef.current = scrollRef.current.firstChild.offsetWidth + 20; // Including margin
    }
  }, [images]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft } = scrollRef.current;
      const scrollTo = direction === 'left'
        ? scrollLeft - itemWidthRef.current
        : scrollLeft + itemWidthRef.current;
      scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  return (
    <div className="homepagedark">
      <div className="bg1">
        <div className="bg-item"></div>
        <div className="line-group">
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
        </div>
      </div>
      <div className="ololade-group">
        <div className="ololade2">
          <span>ABOUT</span>
          <span className="span2">.</span>
        </div>
      </div>
      <div className="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
          <div style={{ position: 'absolute', bottom: 740, left: 980 }}>
            <button className="download-btndark" onClick={handleOpenModal}>
              <div className="download-btndark-child"></div>
              <div className="download-btndark-item"></div>
              <div className="resume1">Visume</div>
              <VideoModal 
                show={showModal} 
                handleClose={handleCloseModal} 
                videoSrc="https://www.youtube.com/embed/dQw4w9WgXcQ" 
              />
            </button>
          </div>
          <div style={{ position: 'absolute', bottom: 740, left: 1150 }}>
            <button className="download-btndark" onClick={handleDownload}>
              <div className="download-btndark-child"></div>
              <div className="download-btndark-item"></div>
              <div className="resume1">Resume</div>
              <img className="akar-iconsdownload1" alt="" src="akariconsdownload.svg" />
            </button>
          </div>
        </div>
      </div>
      <div className="carousel-container">
        <button className="prev" onClick={() => scroll('left')}>&#9664;</button>
        <div className="carousel" ref={scrollRef}>
          {images.map((src, index) => (
            <div key={index} className="carousel-item">
              <img src={src} alt={`Slide ${index}`} className="carousel-image" />
            </div>
          ))}
        </div>
        <button className="next" onClick={() => scroll('right')}>&#9654;</button>
      </div>
      <BottomBar />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <div style={{ position: 'absolute', top: 352, bottom: 0, right: 100 }}>
          <CircularMenu />
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
// import React, { useState, useRef, useEffect } from 'react';
// import SimpleImageSlider from "react-simple-image-slider";
// const images = [
//     { url: "./Github.svg" },
//     { url: "./img_1.jpg" },
//     { url: "images/3.jpg" },
//     { url: "images/4.jpg" },
//     { url: "images/5.jpg" },
//     { url: "images/6.jpg" },
//     { url: "images/7.jpg" },
//   ];
  
//   const ImageCarousel = () => {
//     return (
//       <div>
//         <SimpleImageSlider
//           width={896}
//           height={504}
//           images={images}
//           showBullets={true}
//           showNavs={true}
//         />
//       </div>
//     );
//   }
//   export default ImageCarousel;
